/**
 * A button that opens the system's file picker (slice 5b spec §6): on a
 * phone it offers the camera, photos and Files. Picked files go to
 * `onFiles`; the input is cleared, so the same file can be picked again.
 */
import { Button } from "@crew/ui/components/button";
import { useRef, type ComponentProps, type ReactNode } from "react";
import { ACCEPT } from "./kinds";

export function FilePicker({
  onFiles,
  multiple = true,
  children,
  ...button
}: Omit<ComponentProps<typeof Button>, "onClick" | "children"> & {
  onFiles: (files: File[]) => void;
  multiple?: boolean;
  children: ReactNode;
}) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <>
      <Button type="button" {...button} onClick={() => input.current?.click()}>
        {children}
      </Button>
      <input
        ref={input}
        type="file"
        hidden
        multiple={multiple}
        accept={ACCEPT}
        data-file-input
        onChange={(e) => {
          const files = [...(e.target.files ?? [])];
          e.target.value = "";
          if (files.length) onFiles(files);
        }}
      />
    </>
  );
}
